import { reveal } from "@components/animations";
import { Breadcrumbs } from "@components/shared";
import { educationData } from "@demo-data/education";
import { Container, Stack } from "@mui/system";

export default function EducationPage() {
  return (
    <Container maxWidth="lg">
      <Stack gap={4}>
        <Breadcrumbs
          title="education"
          description={"My educational background"}
        />
        <div className="anim-card-grid">
          {educationData?.map((item, index) => (
            <div key={item.id} {...reveal("up", index * 70)}>
              <div className="anim-skill">
                <h3 className="anim-skill__title">{item.year}</h3>
                <p className="anim-skill__text">{item.title}</p>
                <p className="anim-skill__sub">{item.school}</p>
              </div>
            </div>
          ))}
        </div>
      </Stack>
    </Container>
  );
}
